import React, { PureComponent } from "react";
import { connectStore } from "redux-box";
import { module as pronunciationLexicon } from "@st/pronunciationLexicon";
import {
  Pagination,
  PaginationButton,
  UserDetailsContainer,
  UserDetailValueLabels,
  UserListLoadingContainer,
} from "@c/users-view/MainContent.styled";
import { AutoContainer, ListContainer, EmptyContainer } from "@sc/custom.styled";
import {
  PronunciationField,
  TotalCountLabel,
} from "../PronunciationView.styled";
import PronunciationCard from "./pronunciation-card/PronunciationCard";

class PronunciationList extends PureComponent {
  handlePrevious = () => {
    const { offset, page_size } = this.props.pronunciationLexicon;
    if (offset > 0)
      this.props.pronunciationLexicon.requestListByOffset(
        Math.max(0, offset - page_size)
      );
  };

  handleNext = () => {
    const { has_next, next_page } = this.props.pronunciationLexicon;
    if (has_next)
      this.props.pronunciationLexicon.requestListByOffset(next_page);
  };

  handleDelete = id => {
    this.props.pronunciationLexicon.requestDelete(id);
  };

  render() {
    const {
      list,
      count,
      is_loading,
      has_next,
      offset,
    } = this.props.pronunciationLexicon;
    const { onEdit } = this.props;

    const entries =
      list && list.length > 0 ? (
        list.map(entry => (
          <PronunciationCard
            key={entry.id}
            entry={entry}
            onEdit={onEdit}
            onDelete={this.handleDelete}
          />
        ))
      ) : (
        <EmptyContainer>
          <h4>NO PRONUNCIATION ENTRIES ADDED</h4>
        </EmptyContainer>
      );

    return (
      <UserDetailsContainer>
        <AutoContainer style={{ padding: "0 0 50px 0" }}>
          <UserDetailValueLabels>
            <PronunciationField primary width="18%">
              Word
            </PronunciationField>
            <PronunciationField primary width="20%">
              Respelling
            </PronunciationField>
            <PronunciationField primary width="22%">
              Voice
            </PronunciationField>
            <PronunciationField primary width="25%">
              Notes
            </PronunciationField>
            <PronunciationField primary width="15%" align="center">
              Actions
            </PronunciationField>
          </UserDetailValueLabels>

          {is_loading ? (
            <UserListLoadingContainer>
              <img
                alt="loading"
                width="40"
                height="40"
                src={require("static/img/Theme-loader.gif")}
              />
            </UserListLoadingContainer>
          ) : (
            <ListContainer>{entries}</ListContainer>
          )}
        </AutoContainer>

        <Pagination>
          <TotalCountLabel>{count} entries</TotalCountLabel>
          <PaginationButton
            color={offset > 0 ? "#ff8a23" : "#d5d5d5"}
            onClick={this.handlePrevious}
          >
            <i className="fa fa-chevron-left" />
          </PaginationButton>
          <PaginationButton
            color={has_next ? "#ff8a23" : "#d5d5d5"}
            onClick={this.handleNext}
          >
            <i className="fa fa-chevron-right" />
          </PaginationButton>
        </Pagination>
      </UserDetailsContainer>
    );
  }
}

export default connectStore({ pronunciationLexicon })(PronunciationList);
